import { Typography, Paper, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import avatar from 'src/assets/images/technician.png';
import { useTranslation } from 'react-i18next';
import { handleLogoutMain, getUser } from 'src/utils/Common';
import { useOktaAuth } from '@okta/okta-react';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    paddingTop: '10vh',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'center'
  },
  imageContainer: {
    marginTop: theme.spacing(6),
    display: 'flex',
    justifyContent: 'center'
  },
  image: {
    maxWidth: '100%',
    width: 560,
    maxHeight: 300,
    height: 'auto'
  },
  buttonContainer: {
    marginTop: theme.spacing(6),
    display: 'flex',
    justifyContent: 'center'
  }
}));

function Unauthorized() {
  const { oktaAuth } = useOktaAuth();
  const SessionUser = getUser();
  const classes = useStyles();
  const { t } = useTranslation('common');
  const renderSwitch = (param) => {
    switch (param) {
      case 1:
        return 'Sirius Technician';
      case 2:
        return 'Sirius ServiceShop';
      case 3:
        return 'Sirius CallCenter';
      case 4:
        return 'Sirius HeadOffice';
      case 5:
        return 'Sirius Admin';
      default:
        return 'Sirius ServiceShop';
    }
  }

  const Logout = async () => {
    handleLogoutMain();
    // Will redirect to Okta to end the session then redirect back to the configured `postLogoutRedirectUri`
    // oktaAuth.tokenManager.clear();
    // window.location.href = window.location.origin;
    await oktaAuth.signOut();
  };

  return (
    <Paper style={{ minHeight: 800, overflow: 'auto' }}>
      <br />
      <br />
      <br />
      <Typography align="center" variant={'h1'}>
        {t('lblUnauthorized')}
      </Typography>
      <div className={classes.imageContainer}>
        <img
          alt="Under development"
          className={classes.image}
          src={avatar}
        />
      </div>
      <br />
      <br />
      <Typography align="center" variant={'h5'}>
        {t('lblRoleLabel')}
        <b style={{ color: 'red' }}>{renderSwitch(SessionUser?.Role)}</b>
      </Typography>
      <Typography align="center" variant={'h5'} style = {{marginTop: '2.5vh'}}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => Logout()}
          className={classes.button}
        >
          {t('Relogin')}
        </Button>
      </Typography>

      <br />
      <br />
      <br />
    </Paper>
  );
}

export default Unauthorized;
